document.documentElement.classList.remove('no-js');

const menuButton = document.querySelector('.menu-toggle');
const primaryNavigation = document.querySelector('.primary-navigation');
if (menuButton && primaryNavigation) {
  menuButton.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!open));
    primaryNavigation.classList.toggle('is-open', !open);
  });
}

document.querySelectorAll('[data-collection-sort]').forEach((select) => {
  select.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    window.location.assign(url.toString());
  });
});

const query = new URLSearchParams(window.location.search);
document.querySelectorAll('[data-query-product]').forEach((field) => {
  if (query.get('product')) field.value = query.get('product');
});

document.querySelectorAll('.signup-form').forEach((form) => {
  const whatsappButton = form.querySelector('[data-signup-whatsapp]');
  if (!whatsappButton) return;
  whatsappButton.addEventListener('click', () => {
    if (!form.reportValidity()) return;
    const values = new FormData(form);
    const lines = [
      'Hello Precise Solutions, I would like to enquire about joining the F1RTK correction service.',
      `Name: ${values.get('contact[name]') || 'Not entered'}`,
      `Business/farm: ${values.get('contact[company]') || 'Not entered'}`,
      `Postcode/working area: ${values.get('contact[postcode]') || 'Not entered'}`,
      `Telephone: ${values.get('contact[phone]') || 'Not entered'}`,
      `Requirement: ${values.get('contact[requirement]') || 'Not entered'}`,
      `Receiver/display: ${values.get('contact[equipment]') || 'Not entered'}`,
    ];
    const configuredLink = document.querySelector('.direct-contact a[href*="wa.me/"]')?.href || '';
    const match = configuredLink.match(/wa\.me\/(\d+)/);
    if (match) window.open(`https://wa.me/${match[1]}?text=${encodeURIComponent(lines.join('\n'))}`, '_blank', 'noopener,noreferrer');
  });
});

document.querySelectorAll('[data-f1rtk-subscription-form="true"]').forEach((form) => {
  const subscriptionId = form.querySelector('[data-f1rtk-subscription-id]');
  if (subscriptionId && !subscriptionId.value) {
    subscriptionId.value = window.crypto?.randomUUID?.()
      || `f1rtk-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }
  const variant = form.querySelector('select[name="id"]');
  const planCode = form.querySelector('[data-f1rtk-plan-code]');
  if (variant && planCode) {
    const updatePlanCode = () => {
      const label = variant.options[variant.selectedIndex]?.textContent?.toUpperCase() || '';
      planCode.value = label.includes('F1RTK-SIM') || label.includes('ROAMING SIM') ? 'roaming_sim' : 'service_only';
    };
    variant.addEventListener('change', updatePlanCode);
    updatePlanCode();
  }
});

document.querySelectorAll('[data-support-assistant]').forEach((assistant) => {
  const form = assistant.querySelector('form');
  const endpoint = assistant.dataset.endpoint;
  const answerBox = assistant.querySelector('[data-support-answer]');
  const answer = answerBox?.querySelector('.assistant-response');
  const errorBox = assistant.querySelector('[data-support-error]');
  const errorText = errorBox?.querySelector('p');
  const linksBox = assistant.querySelector('[data-support-links]');
  const question = assistant.querySelector('[name="question"]');
  const product = assistant.querySelector('[name="product"]');
  const submit = form?.querySelector('button[type="submit"]');

  assistant.querySelectorAll('[data-support-question]').forEach((button) => {
    button.addEventListener('click', () => {
      if (question) question.value = button.dataset.supportQuestion || '';
      question?.focus();
    });
  });

  if (query.get('question') && question) question.value = query.get('question');
  if (query.get('product') && product) {
    const requested = query.get('product');
    const option = Array.from(product.options).find((item) => item.value === requested);
    if (option) product.value = requested;
  }

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const text = question?.value?.trim();
    if (!text) return;
    answerBox?.setAttribute('hidden', '');
    errorBox?.setAttribute('hidden', '');
    if (linksBox) linksBox.replaceChildren();
    if (!endpoint) {
      if (errorText) errorText.textContent = 'The secure AI support service has not been connected yet. Please use the official support links or contact Precise Solutions.';
      errorBox?.removeAttribute('hidden');
      return;
    }
    submit.disabled = true;
    submit.textContent = 'Thinking…';
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ question: text, product: product?.value || '' }),
      });
      const payload = await response.json();
      if (!response.ok || !payload.answer) throw new Error(payload.error || 'The support service could not answer just now.');
      if (answer) answer.textContent = payload.answer;
      if (linksBox && Array.isArray(payload.links)) {
        const selectedProduct = product?.value?.trim() || 'Not specified';
        const handoffMessage = [
          'Hello Precise Solutions,',
          '',
          'I used the website AI support assistant and would like further help.',
          `Product or service: ${selectedProduct}`,
          `My question: ${text}`,
          '',
          'AI assistant response:',
          payload.answer,
        ].join('\n');
        const assistantLinks = payload.links.filter((link) => {
          if (!link?.url || !link?.label) return false;
          return !link.url.startsWith('https://wa.me/') && !link.url.startsWith('mailto:');
        });
        assistantLinks.push(
          { label: 'WhatsApp Precise Solutions', url: 'https://wa.me/447850471216' },
          { label: 'Email Precise Solutions', url: 'mailto:sales@precise-solutions.co.uk' },
        );

        assistantLinks.forEach((link) => {
          if (!link?.url || !link?.label) return;
          const item = document.createElement('a');
          if (link.url.startsWith('https://wa.me/')) {
            item.href = `${link.url.split('?')[0]}?text=${encodeURIComponent(handoffMessage)}`;
          } else if (link.url.startsWith('mailto:')) {
            const address = link.url.slice('mailto:'.length).split('?')[0];
            const subject = `Website AI support: ${selectedProduct}`;
            item.href = `mailto:${address}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(handoffMessage)}`;
          } else {
            item.href = link.url;
          }
          item.textContent = `${link.label} ↗`;
          if (link.url.startsWith('http')) {
            item.target = '_blank';
            item.rel = 'noopener';
          }
          linksBox.appendChild(item);
        });
      }
      answerBox?.removeAttribute('hidden');
    } catch (error) {
      if (errorText) errorText.textContent = error instanceof Error ? error.message : 'The support service could not answer just now.';
      errorBox?.removeAttribute('hidden');
    } finally {
      submit.disabled = false;
      submit.innerHTML = 'Ask <span>→</span>';
    }
  });
});
